import { ViewEffects } from "./view.effect";

export const effects: any[] = [ViewEffects]

export * from "./view.effect";
